// extracted by mini-css-extract-plugin
export default {"icondaumen":"Daumenhoch_icondaumen__bp6tQ"};